import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { Button } from 'components/ui/Button/Button'
import { OpsCoreState, OpsTaskSource, IOpsSchedulerState } from 'types/operationsControl.interface'
import { CORE_STATE_META, SOURCE_META, USE_OPS_MOCKS } from './opsControl'
import { BannerText, BannerWrap, DemoBadgeWrap, SchedulerMeta } from './opsShared.styled'

export const DemoBadge = () => (USE_OPS_MOCKS ? <DemoBadgeWrap>Demo data</DemoBadgeWrap> : null)

export const CoreStatePill = ({ state, context }: { state: OpsCoreState; context?: 'task' | 'plan' }) => (
  <StatusPill status={CORE_STATE_META[state].tone}>
    {context === 'task' && state === 'DRAFT' ? 'Queued' : CORE_STATE_META[state].label}
  </StatusPill>
)

export const SourceBadge = ({ source }: { source: OpsTaskSource }) => (
  <StatusPill status={SOURCE_META[source].tone}>{SOURCE_META[source].label}</StatusPill>
)

export const SchedulerBanner = ({
  scheduler,
  onEmergencyGenerate,
}: {
  scheduler: IOpsSchedulerState
  onEmergencyGenerate?: () => void
}) => {
  if (scheduler.status === 'online') {
    return <SchedulerMeta>Scheduler online · last run {scheduler.lastRunAt}</SchedulerMeta>
  }
  const tone = scheduler.status === 'offline' ? 'danger' : 'warning'
  const text =
    scheduler.status === 'offline'
      ? `Scheduler offline since ${scheduler.lastRunAt}. Tasks are not being auto-generated.`
      : `Scheduler encountered errors. Last successful generation: ${scheduler.lastRunAt}.`
  return (
    <BannerWrap $tone={tone}>
      <BannerText $tone={tone}>{text}</BannerText>
      {onEmergencyGenerate && (
        <Button variant={tone === 'danger' ? 'danger' : 'secondary'} size='sm' onClick={onEmergencyGenerate}>
          Emergency generate
        </Button>
      )}
    </BannerWrap>
  )
}
